import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import APIcon from '@t7x000/apex-web/lib/components/common/APIcon/APIcon';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import path from '../../helpers/path';
import { useTranslation } from 'react-i18next';

import './VerificationRequiredComponent.css';

const VerificationRequiredComponent = (props) => {
  const {
    customClass,
    className,
    disabled,
    isUnderReview,
    verificationLevelPageUrl,
    enableOnClick,
    onVerificationLinkClick,
    onClick,
    customKYCMessage,
    history,
    disableKYCLinkUnderReview,
  } = props;

  const { t } = useTranslation();

  const getVerificationRequiredMessage = (isUnderReview, noLink) => {
    if (noLink && isUnderReview) return t('You are not yet verified. Verification under review.');
    else if (noLink) return t('You are not yet verified. Verify your identity to start trading.');
    else if (isUnderReview) return t('Verification under review. Click here to check your verification status.');
    else return t('Verify your identity to start trading. Click here to verify.');
  };

  const noLink = disableKYCLinkUnderReview ? isUnderReview : verificationLevelPageUrl === '';
  const bemClasses = getBEMClasses(['verification-required-banner', customClass]);
  const handleOnVerificationLinkClick = () => {
    if (verificationLevelPageUrl.match(/^http/)) {
      window.location.href = verificationLevelPageUrl;
    } else {
      history.push(path(verificationLevelPageUrl));
      if (enableOnClick) onVerificationLinkClick();
    }
  };

  if (disabled)
    return (
      <div className={bemClasses('container')}>
        <div
          className={bemClasses(noLink ? 'no-link' : '')}
          onClick={() => {
            if (noLink) return;
            handleOnVerificationLinkClick();
            onClick && onClick();
          }}>
          <APIcon name="alert" customClass={bemClasses('warning')} classModifiers="small" />
          <span className={`ap--label ${bemClasses('not-verified')} ${className}`}>
            {customKYCMessage ? customKYCMessage : getVerificationRequiredMessage(isUnderReview, noLink)}
          </span>
        </div>
      </div>
    );
  return null;
};

VerificationRequiredComponent.defaultProps = {
  className: '',
  onVerificationLinkClick: () => {},
  isUnderReview: false,
  disabled: false,
  enableOnClick: true,
  disableKYCLinkUnderReview: false,
};

VerificationRequiredComponent.propTypes = {
  className: PropTypes.string,
  verificationLevelPageUrl: PropTypes.string.isRequired,
  onVerificationLinkClick: PropTypes.func.isRequired,
  isUnderReview: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  enableOnClick: PropTypes.bool,
  customKYCMessage: PropTypes.string,
};

export default withRouter(VerificationRequiredComponent);
